import React, { useContext, useState } from "react";
import { ButtonComponent, AnchorComponent } from "../../components/elements";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { BASE_URL, TOKEN, CURRENT_IP } from "../../helper/BASE_URL";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { IoMdMail } from "react-icons/io";

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [IsLoading, setIsLoading] = useState(false);
  const [setshowOtp, setSetshowOtp] = useState(false);
  const [setshowMessage, setSetshowMessage] = useState("");

  const navigate = useNavigate();

  const Handle_Login = () => {
    setIsLoading(true);

    try {
      axios
        .post(
          BASE_URL + "send_login_otp.php",
          {
            reg_em: email,
            ip_addr: window.localStorage.getItem("bpipos")
              ? window.localStorage.getItem("bpipos")
              : "224.234.50.218",
          },
          {
            headers: {
              ClientKey: TOKEN,
            },
          }
        )
        .then((acc) => {
          console.log(acc.data);
          setIsLoading(false);

          if (acc.data.status == "FAILED") {
            toast.error(acc.data.message);
          } else {
            if (Number(email)) {
              setSetshowMessage(`Your OTP is sent to: ${acc.data.data.email}`);
            }

            toast.success(acc.data.message);
            setSetshowOtp(true);
          }
        })
        .catch((err) => {
          setIsLoading(false);

          console.log(err);
        });
    } catch (error) {
      setIsLoading(false);

      console.log(error);
    }
  };

  const Handle_Enter_OTP = () => {
    setIsLoading(true);
    setSetshowMessage("");
    try {
      axios
        .post(
          BASE_URL + "verify_login_otp.php",
          {
            reg_em: email,
            otp: otp,
            ip_addr: window.localStorage.getItem("bpipos")
              ? window.localStorage.getItem("bpipos")
              : "224.234.50.218",
          },
          {
            headers: {
              ClientKey: TOKEN,
            },
          }
        )
        .then((acc) => {
          console.log(acc.data);

          setIsLoading(false);

          if (acc.data.status == "FAILED") {
            toast.error(acc.data.message);
          } else {
            toast.success(acc.data.message);

            localStorage.setItem("jwt", JSON.stringify(acc.data.data));
            navigate("/");
          }
        })
        .catch((err) => {
          setIsLoading(false);

          console.log(err);
        });
    } catch (error) {
      setIsLoading(false);

      console.log(error);
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
      <ToastContainer />
      <div
        className="position-relative w-100 h-100 overflow-hidden shadow-md"
        style={{
          backgroundImage:
            "linear-gradient(rgb(255, 193, 7) 0%, rgb(222 159 64) 100%)",
        }}
      >
        {/* Background images */}
        <img
          className="position-absolute top-0 d-none d-md-block"
          style={{ transform: "scale(1.05)", maxWidth: "100%", height: "auto" }}
          src="/login_background.PNG"
          alt="Background"
        />
        <img
          className="position-absolute bottom-0 d-block d-md-none"
          style={{ transform: "scale(1.05)", maxWidth: "100%", height: "120%" }}
          src="/login_background_vertical.PNG"
          alt="Background"
        />

        {/* Overlay */}
        <div className="position-absolute w-100 h-100 bg-transparent"></div>

        <div className="d-flex align-items-center justify-content-evenly vh-100 bg-cover bg-center bg-no-repeat overflow-y-auto position-relative">
          <div className="w-100 rounded position-relative">
            <div className="d-flex flex-column justify-content-evenly rounded position-relative">
              <div className="d-flex flex-column flex-md-row w-100 justify-content-evenly mx-auto py-4 gap-2 vh-100">
                {/* Left Section */}
                <div className="d-none d-md-flex flex-column justify-content-evenly px-4 w-100">
                  <div>
                    <h3 className="text-center text-uppercase text-black">
                      Welcome to
                    </h3>
                    <h1 className="text-center text-uppercase font-weight-bold text-black">
                      BOSS PANDA
                    </h1>
                  </div>
                  <div className="d-flex flex-column align-items-center">
                    <img
                      src="/logo.png"
                      alt="boss panda"
                      className="align-self-center mb-3"
                      width={230}
                      height={230}
                    />
                    <p
                      style={{ fontWeight: 800, fontSize: "large" }}
                      className="text-center font-weight-bold text-black"
                    >
                      Get set up in minutes!
                    </p>
                  </div>

                  <div className="d-flex flex flex-lg-column-reverse align-items-center justify-content-center gap-2 text-black">
                    <p
                      onClick={() => navigate("/register")}
                      style={{
                        fontWeight: 800,
                        fontSize: "large",
                        color: "blue",
                      }}
                      className=" cursor-pointer text-decoration-none"
                    >
                      Register
                    </p>
                    <p>Don't have an account?</p>
                  </div>
                </div>

                <div
                  style={{ alignItems: "center" }}
                  className="d-flex flex-column justify-content-evenly d-md-none mt-0 alif"
                >
                  <img
                    src="/logo.png"
                    alt="BossPanda"
                    width={150}
                    height={150}
                  />

                  <h5 style={{ marginTop: 10, color: "#514b4b" }}>
                    Welcome to Boss Panda
                  </h5>
                  <br></br>
                  <br></br>
                  <h3 style={{ color: "black" }}>Login Below</h3>
                </div>

                {setshowOtp ? (
                  <form className="d-flex flex-column justify-content-center w-100 px-4 px-md-5 text-black">
                    <p
                      style={{
                        textAlign: "center",
                        color: "black",
                        marginTop: 15,
                        fontWeight: 600,
                      }}
                    >
                      {setshowMessage ? setshowMessage : ""}
                    </p>

                    <p
                      className="position-static top-0 end-0 d-none w-100 text-center fs-1 fw-bold mb-md-10 d-md-block"
                      style={{ color: "black" }}
                    >
                      Enter OTP
                    </p>

                    <style jsx>{`
                      input::placeholder {
                        color: #383732;

                        font-weight: 500;
                      }

                      select {
                        color: #383732;
                        font-weight: 200;
                      }
                    `}</style>

                    <div className="position-relative mb-3">
                      <input
                        value={otp}
                        onChange={(e) => setOtp(e.target.value)}
                        style={{
                          fontWeight: "bold",
                          color: "black",
                          fontSize: "15px",
                        }}
                        type="text"
                        placeholder="Enter OTP"
                        className="bold-black-input bold-input w-100 ms-2 border-bottom border-dark text-black p-3 text-15 ps-4 fw-semibold placeholder-white-dark focus:outline-none"
                      />

                      <div className="position-absolute start-4 top-50 translate-middle-y">
                        <IoMdMail size={25} style={{ color: "#f0ba18" }} />
                      </div>
                    </div>
                    <p style={{ marginTop: "2px", color: "blue" }}>
                      Check your email for OTP
                    </p>
                    <ButtonComponent
                      handleClick={Handle_Enter_OTP}
                      disabled={IsLoading}
                      className="mc-btn primary"
                      icon="arrow_forward"
                      text={"Proceed"}
                      style={{
                        background: "#f0ba18",
                        color: "black",
                      }}
                    />

                    <div className="d-flex justify-content-center gap-4 mt-1 d-md-none">
                      <p
                        className="cursor-pointer text-decoration-none"
                        onClick={() => navigate("/register")}
                      >
                        Don't have an account? &nbsp;&nbsp;
                        <span style={{ color: "blue" }}>Register</span>
                      </p>
                    </div>
                    <p
                      style={{
                        textAlign: "center",
                        color: "black",
                        marginTop: 15,
                        fontWeight: 600,
                      }}
                    >
                      © BossPanda All Rights Reserved
                    </p>
                  </form>
                ) : (
                  <form className="d-flex flex-column justify-content-center w-100 px-4 px-md-5 text-black">
                    {/* setshowMessage */}

                    <p
                      className="position-static top-0 end-0 d-none w-100 text-center fs-1 fw-bold mb-md-10 d-md-block"
                      style={{ color: "black" }}
                    >
                      Login
                    </p>

                    <style jsx>{`
                      input::placeholder {
                        color: #383732;

                        font-weight: 500;
                      }

                      select {
                        color: #383732;
                        font-weight: 200;
                      }
                    `}</style>

                    <div className="position-relative mb-3">
                      <input
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        style={{
                          fontWeight: "bold",
                          color: "black",
                          fontSize: "15px",
                        }}
                        type="email"
                        placeholder="Enter Your Email / Mobile Number "
                        className="bold-black-input bold-input w-100 ms-2 border-bottom border-dark text-black p-3 text-15 ps-4 fw-semibold placeholder-white-dark focus:outline-none"
                      />
                      <div className="position-absolute start-4 top-50 translate-middle-y">
                        <IoMdMail size={25} style={{ color: "#f0ba18" }} />
                      </div>
                    </div>

                    <ButtonComponent
                      handleClick={Handle_Login}
                      disabled={IsLoading}
                      className="mc-btn primary"
                      icon="arrow_forward"
                      text={"Proceed"}
                      style={{
                        background: "#f0ba18",
                        color: "black",
                      }}
                    />

                    <div className="d-flex justify-content-center gap-4 mt-1 d-md-none">
                      <p
                        className="cursor-pointer text-decoration-none"
                        onClick={() => navigate("/register")}
                      >
                        Don't have an account? &nbsp;&nbsp;
                        <span style={{ color: "blue" }}>Register</span>
                      </p>
                    </div>
                    <p
                      style={{
                        textAlign: "center",
                        color: "black",
                        marginTop: 15,
                        fontWeight: 600,
                      }}
                    >
                      © BossPanda All Rights Reserved
                    </p>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
